import CardHeader from './CardHeader';
import CardBody from './CardBody';
import CardFooter from './CardFooter';

import styles from './Card.module.scss';

const Card = ({ className, children }) => {
  return (
    <>
      <div data-test-id='card-hcu-data' className={`${styles.card} ${className}`}>
        {children}
      </div>
    </>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
